import { TextField } from "@/components/TextField/TextField";
import type { FlightFormLocation } from "@/types/types";
import { getCityName } from "@/utils/locations";

type LocationPickerProps = {
  value: FlightFormLocation | null;
  label: React.ReactNode;
  errorMessage?: string;
  startIcon?: React.ReactNode;
  shouldShowCode?: boolean;
  onPickerOpen: () => void;
};

export function LocationPicker({
  label,
  value,
  startIcon,
  errorMessage,
  shouldShowCode = true,
  onPickerOpen,
}: LocationPickerProps) {
  return (
    <TextField
      fullWidth
      onClick={onPickerOpen}
      startAdornment={startIcon}
      inputControl={{ truncate: true, noSelect: true }}
      value={`${getCityName(value)}${shouldShowCode && value?.code ? ` (${value.code})` : ""}`}
      error={!!errorMessage}
      helperText={errorMessage}
      label={label}
    />
  );
}
